import {
  Insight,
  InsightLanguageDistribution,
} from '@/services/dashboard-service/dashboard.service.types';
import { calculatePercentage } from '@/utils/helpers';
import { Col, Flex, FlexProps, Row } from 'antd';
import styles from './content-wrapper.module.scss';
import { Button } from '@/components/button/button';

interface ContentWrapperProps {
  content: Insight | InsightLanguageDistribution;
  sumOfData: number;
  wrapperProps: Partial<FlexProps>;
  indexValues?: boolean;
  vertical?: boolean;
  isButton?: boolean;
  onButtonClick?: () => void;
}

export default function ContentWrapper({
  wrapperProps,
  sumOfData,
  content,
  indexValues = false,
  vertical = false,
  isButton = false,
  onButtonClick,
}: ContentWrapperProps) {
  const colorClasses = ['purple1', 'purple2', 'purple3', 'red1', 'red2'];

  const getValue = (
    value: number | null | { count: number; language_flag_url: string | null }
  ): number | null => {
    if (typeof value === 'object' && value !== null && 'count' in value) {
      return value.count;
    }
    return value;
  };

  return (
    <Flex {...wrapperProps}>
      {Object.keys(content)
        .slice(0, colorClasses.length)
        .map((key, index) => {
          const numericValue = getValue(content[key]);
          const percentageValue = calculatePercentage(numericValue, sumOfData);
          const title = indexValues ? `${index + 1}. "${key}"` : key;

          if (numericValue === null || numericValue === 0) {
            return null;
          }

          const displayValue = numericValue ?? 0;

          return (
            <Row
              key={key}
              className={
                vertical ? styles.indicatorVerticalContainer : styles.indicatorHorizontalContainer
              }
            >
              <Col
                className={
                  vertical ? styles.firstColVerticalContainer : styles.firstColHorizontalContainer
                }
              >
                <span className={styles.indicatorTitle}>{title}</span>
                <span
                  key={`indicator-${index}`}
                  className={`${styles[colorClasses[index]]} ${
                    vertical ? styles.horizontalIndicator : styles.verticalIndicator
                  }`}
                ></span>
              </Col>
              <Col
                className={
                  vertical ? styles.secondColVerticalContainer : styles.secondColHorizontalContainer
                }
              >
                <span className={styles.percentage}>{`${percentageValue}%`}</span>
                <span className={styles.count}>{displayValue}</span>
              </Col>
            </Row>
          );
        })}

      {isButton && (
        <Button style={{ marginTop: '20px' }} onClick={onButtonClick} buttonVariant="secondary">
          See more
        </Button>
      )}
    </Flex>
  );
}
